module.exports = __webpack_public_path__ + "static/media/mladenTim.f370f664.jpg";